var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, Watch, PropertyConverters, Utils } from './_default-imports';
//namespace Pacem.Components {
let PacemTextElement = class PacemTextElement extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        if (this.childNodes.length == 0) {
            this.innerHTML = '&nbsp;';
        }
        this._text = this.childNodes.item(0);
    }
    propertyChangedCallback(name, old, val, first) {
        if (Utils.isNull(val) && first === true)
            return;
        this._text.nodeValue = val;
    }
};
__decorate([
    Watch({ emit: false /*, debounce: true*/, converter: PropertyConverters.String })
], PacemTextElement.prototype, "text", void 0);
PacemTextElement = __decorate([
    CustomElement({ tagName: P + '-text' })
], PacemTextElement);
export { PacemTextElement };
//}
